<template>
    <v-card outlined>
        <v-card-title>
            {{ $t('admin_panel.suggestion-blobs.title')|toUppercase }}
        </v-card-title>
        <v-card-text>
            <v-data-table
                    :headers="headers"
                    :items="blobSuggestions"
                    item-key="id"
                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    show-expand
                    hide-default-footer
            >
                <div></div>
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            @click="openFormDialog({})"
                        >
                            <v-icon>mdi-plus</v-icon>
                            {{ $t('admin_panel.suggestion-blobs.add') }}
                        </v-btn>
                    </v-toolbar>
                </template>

                <template v-slot:item.created_at="{ item }">
                    {{ item.created_at|formatDate }}
                </template>

                <template v-slot:item.is_public="{ item }">
                    <v-simple-checkbox
                        v-model="item.is_public"
                        disabled
                    ></v-simple-checkbox>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            @click="openFormDialog(item)"
                    >
                        mdi-pencil
                    </v-icon>
                </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-data-table
                    :headers="linkingHeaders"
                    :items="linkings.filter(l => l.blob_suggestion_id === item.id)"
                    item-key="id"
                    hide-default-footer
                  >
                    <template v-slot:item.created_at="{ item }">
                      {{ item.created_at|formatDate }}
                    </template>
                  </v-data-table>
                </td>
              </template>
            </v-data-table>
        </v-card-text>

        <v-dialog v-model="dialog" persistent max-width="600px">
            <BlobSuggestionForm
                    v-if="dialog"
                    :blob="curBlob"
                    :cancel="true"
                    @blobIsProcessed="doneEditing"
                    @blobIsCanceled="closeDialog"
            ></BlobSuggestionForm>
        </v-dialog>
    </v-card>
</template>


<script>
  import { mapGetters } from 'vuex'
  import BlobSuggestionForm from '../../components/Admin/BlobSuggestionForm'

  export default {
    name: 'BlobSuggestions',
    components: { BlobSuggestionForm  },
    data () {
      return {
        expanded: [],
        singleExpand: true,
        headers: [
          { text: 'created at', value: 'created_at', sortable: true},
          { text: 'published', value: 'is_public', align: 'center', sortable: true},
          { text: 'added', value: 'add_counter', align: 'center', sortable: true},
          { text: 'language', value: 'locale', sortable: true},
          { text: 'country', value: 'country', sortable: true},
          { text: 'name', value: 'name', sortable: true},
          { text: 'actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' },
        ],
        linkingHeaders: [
          { text: 'added at', value: 'created_at', sortable: true},
          { text: 'user', value: 'user', sortable: true},
          { text: 'radar', value: 'radar', sortable: true},
        ],
        dialog: false,
        curBlob: {}
      }
    },
    computed: {
      ...mapGetters({
        blobSuggestions: 'admin/blobSuggestions',
        linkings: 'admin/blobSuggestionLinkings'
      })
    },
    mounted () {
      this.$store.dispatch('admin/loadBlobSuggestion');
      this.$store.dispatch('admin/loadBlobSuggestionLinkings');
    },
    methods: {
      openFormDialog(blob) {
        this.curBlob = blob;
        this.dialog = true;
      },

      doneEditing () {
        this.dialog = false
      },

      closeDialog () {
        this.dialog = false
      },
    }
  }
</script>
